// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all[data-v-6b1aceb9]{margin:0 auto;text-align:center}.all .pice_item[data-v-6b1aceb9]{display:flex;align-items:center}.all .pice_item .item_input input[data-v-6b1aceb9]{border-bottom:.052083rem solid #ccc}.all .pice_item .item_title[data-v-6b1aceb9]{width:10.416667rem}.content[data-v-6b1aceb9]{text-align:center}.content .el-button[data-v-6b1aceb9]{margin-top:1.041667rem}", ""]);
// Exports
module.exports = exports;
